import { createTheme, type MantineTheme } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import type { PartialDeep } from 'type-fest';

import { inputStyles, themedMantineInput } from './Input';

export const ThemedMantineDatePickerInput: PartialDeep<MantineTheme> = createTheme({
  components: {
    DatePickerInput: DatePickerInput.extend({
      defaultProps: {
        valueFormat: 'L',
      },
      styles: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return themedMantineInput(theme);
      },
      classNames: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return { input: inputStyles.input(theme) };
      },
    }),
  },
});
